import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=279a067c&scoped=true&"
import script from "./parent.vue?vue&type=script&lang=js&"
export * from "./parent.vue?vue&type=script&lang=js&"
import style0 from "./parent.vue?vue&type=style&index=0&id=279a067c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a067c",
  null
  
)

export default component.exports